<template>
  <div class="private-background">
    <div :class="{ height : mobile && subNav }">
      <app-header @dialogHandler="dialogHandler" />
        <side-bar class="web-view" />
        <mobile-side-nav class="mobile-view" @closeDrawer="closeDrawer" :drawer="dialog"/>
        <div class="main">
          <transition name="fade" mode="out-in">
            <slot />
          </transition>
        </div>
        <div class="app-nav">
          <mobile-sub-nav :subNavRoutes="subNavRoutes" v-if="mobile && subNav"/>
        </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/app-header.vue";
import SideBar from "@/components/app-side-nav";
import MobileSubNav from "@/components/mobile-sub-nav.vue"
import MobileSideNav from '../components/mobile-side-nav.vue';

import Navigations from "@/http/navigations.js";

export default {
  components: {
    AppHeader,
    MobileSideNav,
    SideBar,
    MobileSubNav,
    
  },
  data:() => ({
    dialog:false,
    mobile:true,
    subNav : false,
    subNavRoutes:[]
  }),
  mounted(){
    this.responsive();
    this.navWatcher()
  },
  methods:{
    dialogHandler(){
      this.dialog = true
    },
    closeDrawer(){
      this.dialog = false
    },
    responsive(){
      let breakpoint = 1024;
      if(screen.width >= breakpoint ){
        this.mobile = false
      }
      else if(screen.width < breakpoint){
        this.mobile = true
      }
    },
    navWatcher(){
    
      let objNav = Navigations.find(obj => obj.to == this.$route.path);
      console.log('route2', objNav);
      if(objNav.subNav){
        console.log('entered here', this.mobile);
        this.subNav = true;
        this.subNavRoutes = objNav.subNav;
      }
      else{
        this.subNav = false
      }
    }
  },
  watch:{
    $route (){
        this.navWatcher()
    }
} 

  // TODO : MOVE responsive() to store 
};
</script>

<style lang="scss" scoped>
.private-background {
  min-height: 100vh;
  background: #f8f7fc;

  .height{
    // height: calc(100% - 50px) !important;
    margin-bottom: 50px !important;
    overflow-y: scroll;
  }
}
.mobile-view{
  display: none;
}
.web-view{
  display: none;
}
.app-nav {
    position: fixed;
    bottom: 0;
    z-index: 10;
    width: 100%;
  }
.main{
  height: calc(100% - 100px) !important;
}
@media only screen and (max-width: 1023px){
  .mobile-view{
    display: block;
  }
}
@media only screen and (min-width: 1024px){
  .web-view{
    display: block;
  }
}
</style>